import { Component, OnInit, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { WINDOW } from '@ng-toolkit/universal';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
declare var bootstrap: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'trinkaWeb';
  constructor(@Inject(WINDOW) private window: Window,
    @Inject(PLATFORM_ID) private platformId: Object) { }

  onActivate(event) {
    if (isPlatformBrowser(this.platformId)) {
      this.window.scroll(0, 0);
    }
    //or document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)
  }
  ngOnInit(){
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
  }

  ngAfterViewInit(): void {
    // Open the modal when the component view is initialized
    // if (isPlatformBrowser(this.platformId)) {
    //   const modal = new bootstrap.Modal(document.getElementById('promotionModal'));
    //   modal.show();  // Show the modal
    // }
  }

  isShow: boolean;
  topPosToStartShowing = 100;

  @HostListener('window:scroll')
  checkScroll() {
    if (isPlatformBrowser(this.platformId)) {

      const scrollPosition = this.window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      // console.log('[scroll]', scrollPosition);

      if (scrollPosition >= this.topPosToStartShowing) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    }
  }
  gotoTop() {
    if (isPlatformBrowser(this.platformId)) {

      this.window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
}

